import React, { Component } from 'react';
import _ from 'lodash';
import { API_BASE_URL, API_KEY } from '../../../config/config';
import { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';

export default class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      items: [],
      isLoaded: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    this.getItems(this.props.coverageId, this.props.halfTime);
    this.refreshItems(this.props.coverageId, this.props.halfTime);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getItems(coverageId, halfTime) {
    fetch(`${API_BASE_URL}/coveragecomments/${coverageId}`, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-API-KEY': API_KEY,
        'X-Request-ID': uuidv4()
      }
    })
      .then((res) => res.json())
      .then(
        (json) => {
          this.setState({
            isLoaded: true,
            items: _.filter(json, { half_id: parseInt(halfTime) }),
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        },
      );
  }

  refreshItems(id, halftime) {
    this.timer = setInterval(() => {
      this.getItems(id, halftime);
    }, 120000);
  }

  render() {
    const { error, isLoaded, items } = this.state;

    if (error) {
      return <div>Hiba történt!</div>;
    } if (!isLoaded) {
      return <div>Betöltés</div>;
    }
    return (
      <div>
        {items.map((item) => (
          <Fragment key={item.id}>
            {!!item.text && (
              <div className="match-centre__comment" dangerouslySetInnerHTML={{ __html: item.text }} />
            )}
          </Fragment>
        ))}
      </div>
    );
  }
}
